import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { AuthService, AuthStorageService, BaseSiteService, UserIdService } from '@spartacus/core';
import { Observable, catchError, map, switchMap, take, tap, throwError } from 'rxjs';
import { PostPlacedOrderPayload } from 'src/app/model/checkout.model';
import { ShimanoUtilMethod } from 'src/app/utility/methods.util';
import { environment } from 'src/environments/environment';
import { CheckoutServiceExtends } from '../checkout/checkout.service';
import { ComponentService } from '../component.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl.content}${environment.prefix}${this.baseSiteId}`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseService
      .getActive()
      .pipe(take(1))
      .subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userIdService
      .getUserId()
      .pipe(take(1))
      .subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  constructor(
    protected cartService: ActiveCartFacade,
    protected http: HttpClient,
    protected auth: AuthService,
    protected userIdService: UserIdService,
    protected authStorageService: AuthStorageService,
    protected baseService: BaseSiteService,
    protected componentService: ComponentService,
    private checkoutServiceExtends: CheckoutServiceExtends,

    private meta: Meta
  ) {}

  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => errorMessage);
  }

  getPaymentModes(): Observable<HttpEvent<any>> {
    return this.cartService.takeActiveCartId().pipe(
      take(1),
      switchMap((cartId) => this.http.get(`${this.url}/users/${this.userCurrent}/carts/${cartId}/paymentModes`)),
      map((res: any) => res.paymentModes),
      catchError(this.errorHandl)
    );
  }

  getPaymentSession(payload: PostPlacedOrderPayload): Observable<HttpEvent<any>> {
    const body = {
      paymentMode: { code: payload.paymentMode.code },
      payloadRequest: ShimanoUtilMethod.encodeObjectToBase64({
        redirecturl: `${window.location.href.replace('/checkout', '/payment-confirmation')}/${payload.cartId}`,
        openiniframe: 'Y',
      }),
      placeOrderRequest: ShimanoUtilMethod.encodeObjectToBase64(
        this.checkoutServiceExtends.buildPlaceOrderBody(payload)
      ),
    };

    return this.http
      .post(`${this.url}/users/${this.userCurrent}/carts/${payload.cartId}/payment/session`, body, {
        headers: this.headers,
      })
      .pipe(
        map((res: any) => res),
        catchError(this.errorHandl)
      );
  }

  getPaymentStatus(cartId: string, ref: string): Observable<HttpEvent<any>> {
    return this.http
      .get(`${this.url}/users/${this.userCurrent}/carts/${cartId}/payment/status?ref=${ref}`)
      .pipe(map((res: any) => res));
  }

  verifyPayment(cartId: string): Observable<HttpEvent<any>> {
    return this.http
      .get(`${this.url}/users/${this.userCurrent}/carts/${cartId}/payment/verification`)
      .pipe(map((res: any) => res));
  }

  getInvoiceSSOToken(): Observable<any> {
    return this.http.get(`${this.url}/users/${this.userCurrent}/snappay/ssotoken`).pipe(
      map((data) => data),
      catchError(this.errorHandl)
    );
  }
  redirectToSnappayInvoice(): Observable<any> {
    this.fullPageOverlaySpinner('show');
    let snapPayUrl: string;

    return this.getInvoiceSSOToken().pipe(
      tap((invoiceToken: any) => {
        if (invoiceToken) {
          snapPayUrl = `${invoiceToken.baseUrl}/SSO/index?reqno=${invoiceToken.token}`;
          window.open(snapPayUrl, '_blank');
        }
      })
    );
  }

  fullPageOverlaySpinner(value: string): void {
    const cxStorefront = document.querySelector('cx-storefront');
    if (value === 'show') {
      cxStorefront?.classList.add('fp-overlay-spinner');
      document.documentElement.classList.add('no-scroll');
    } else {
      cxStorefront?.classList.remove('fp-overlay-spinner');
      document.documentElement.classList.remove('no-scroll');
    }
  }
}
